document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('[data-before-after-slider]');

  sliders.forEach(function (slider) {
    var startPosition = parseFloat(slider.getAttribute('data-start-position')) || 50;
    setReveal(slider, startPosition);

    var handle = slider.querySelector('[data-before-after-handle]');
    var isDragging = false;

    function setReveal(el, percent) {
      percent = Math.max(0, Math.min(100, percent));
      el.style.setProperty('--reveal', percent + '%');
    }

    function updateFromClientX(clientX) {
      var rect = slider.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      setReveal(slider, percent);
      slider.setAttribute('data-interacted', 'true');
    }

    function onPointerDown(e) {
      isDragging = true;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      updateFromClientX(clientX);
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      updateFromClientX(clientX);
    }

    function onPointerUp() {
      isDragging = false;
    }

    if (handle) {
      handle.addEventListener('mousedown', onPointerDown);
      handle.addEventListener('touchstart', onPointerDown, { passive: false });
    }

    slider.addEventListener('mousedown', onPointerDown);
    slider.addEventListener('touchstart', onPointerDown, { passive: false });

    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: false });
    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);

    // Keyboard accessibility: left/right arrow keys move the handle
    if (handle) {
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(slider.style.getPropertyValue('--reveal')) || startPosition;
        if (e.key === 'ArrowLeft') {
          setReveal(slider, current - 5);
          slider.setAttribute('data-interacted', 'true');
        } else if (e.key === 'ArrowRight') {
          setReveal(slider, current + 5);
          slider.setAttribute('data-interacted', 'true');
        }
      });
    }
  });
});